import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Container } from 'reactstrap';
import ListSearch from './listSearch';
import ListResult from './listResult';
import { NavLink as RouterNavLink } from 'react-router-dom';
import { listRequest as listRequestAction, listClear as listClearAction } from '../../store/trainers/actions'
import { getTrainers } from '../../store/trainers/selectors';
import { getSelectedUser } from '../../store/users/selectors';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import {
    Button, Col, Row, Spinner, Form, FormGroup, Input,
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Label
} from 'reactstrap';
import OrganiserTopNav from '../../components/organiserTopNav';
import { timeStamp } from 'console';

interface IState {
    organiserId : string
    term: string
    sorting: string
    offset: number
    limit: number
}

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    userData : any
    data: any
    ui: any
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest: typeof listRequestAction
    listClear: typeof listClearAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class TrainerMainPage extends React.Component<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        let limit = this.props.ui?.searchParams?.limit ?? 10;
        if (limit === 1) limit = 10;
        this.state = {
            organiserId : this.props.ui?.searchParams?.organiserId ?? '',
            term: this.props.ui?.searchParams?.term ?? '',
            sorting: this.props.ui?.searchParams?.sorting ?? '',
            offset: this.props.ui?.searchParams?.offset ?? 0,
            limit: limit
        };
    }

    public componentDidMount() {
        let organiserId = this.props.route.match.params.organiserId;
        const parsed = queryString.parse(this.props.route.location.search);
        const { searchParams: stateSP } = this.props.ui;

        var sTerm = '';
        var sSorting = '';
        if (parsed.term) sTerm = parsed.term.toString();
        if (parsed.sorting) sSorting = parsed?.sorting.toString() ?? "Title";

        // Compare if different only query again
        let isNewSearch = true;
        if ((stateSP != undefined) && (
            stateSP.organiserId === organiserId  &&
            stateSP.term === sTerm &&
            stateSP.sorting === sSorting &&
            stateSP.offset === this.state.offset &&
            stateSP.limit === this.state.limit
        )) {
            isNewSearch = false;
        }

        if (isNewSearch) {
            this.setState({
                organiserId : organiserId,
                term: sTerm,
                sorting: sSorting
            }, () => {
                this.ListRequest();
            });
        }

        if (this.props.userData === undefined){
            //this.props.selectUserData(id);
        }
    }

    componentDidUpdate(prevProps: AllProps) {
        // Show notification
        if (prevProps.ui.processState != this.props.ui.processState) {
            let notification = { show: false, title: "", type: "", message: "" };

            if (this.props.ui.processState === 1) { // List success

            } else if (this.props.ui.processState === 2) { // List failed
                notification.show = true;
                notification.type = "danger";
                notification.message = "Process failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show) {
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                });
            }
        }
    }

    public componentWillUnmount() {
    }

    private Search(d: any) {
        this.setState({
            offset: 0,
            term: d?.term ?? "".toLowerCase(),
        }, () => {
            this.props.route.history.push('?term=' + d.term + '&sorting=' + this.state.sorting);
            this.ListRequest();
        });
    }
    private LoadMore(d: any) {
        this.setState({ offset: this.state.offset + this.state.limit }, () => {
            this.ListRequest();
        });
    }

    private Sorting(d: any) {
        this.setState({ offset: 0, sorting: d.searchSorting }, () => {
            this.props.route.history.push('?term=' + this.state.term + '&sorting=' + this.state.sorting);
            this.ListRequest();
        });
    }
    private ListRequest(){
        var searchParams: any = {};
        searchParams["organiserId"] = this.state.organiserId;
        searchParams["term"] = this.state.term;
        searchParams["sorting"] = this.state.sorting;
        searchParams["offset"] = this.state.offset;
        searchParams["limit"] = this.state.limit;
        this.props.listRequest(searchParams);
    }

    public render() {
        const { ui } = this.props.ui;
        return (
            <div className="bg-light container">
                <OrganiserTopNav activeTab = "Trainers" organiserId ={this.state.organiserId} />
                <ListSearch onSearch={this.Search.bind(this)}
                    term={this.state.term}
                    loading={this.props.ui.loading} />
                <br />
                <RouterNavLink to={"/organisers/" + this.state.organiserId + "/trainers/new"}><Button color="success">
                    <i className="fas fa-plus mr-1"></i>Add New</Button></RouterNavLink>
                <ListResult
                    onLoadMore={this.LoadMore.bind(this)}
                    onSorting={this.Sorting.bind(this)}
                    term={this.state.term}
                    sorting={this.state.sorting}
                    data={this.props.data}
                    loading={this.props.ui.loading}
                    totalDocument={this.props.ui.totDoc}
                    offset={this.state.offset} limit={this.state.limit} />
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.trainer.ui,
    selectedUserId : state.user.ui.selected,
    data: getTrainers(state),
    userData : getSelectedUser(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest: listRequestAction,
    listClear: listClearAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrainerMainPage)
